import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/TemplatePage.css';
import { baseUrl } from '../config';



const TemplatePage = () => {
  const location = useLocation();
  const { file } = location.state || {}; // Retrieve file from state

  const [selectedLines, setSelectedLines] = useState([]);
  const [selectedTimeFrames, setSelectedTimeFrames] = useState([]);
  const [generatedTemplate, setGeneratedTemplate] = useState(null);

  if (!file) {
    return <p>No file selected</p>; // Handle case where no file is passed
  }

  const handleGenerateTemplate = () => {
    // Placeholder function for AI template generation
    // Replace this with your actual integration
    const generated = `Generated template based on selected lines or time frames.`;
    setGeneratedTemplate(generated);
  };

  const handleDownloadTemplate = () => {
    if (generatedTemplate) {
      const blob = new Blob([generatedTemplate], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'template.txt';
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  return (
    <div className="template-page">
      <h2>Template Page</h2>
      <div className="file-preview">
        {file.imageUrl.endsWith('.pdf') ? (
          <div className="pdf-preview">
            {/* Placeholder PDF preview logic */}
            <p>PDF Preview: {file.name}</p>
            {/* Implement PDF rendering logic */}
          </div>
        ) : (
          <div className="video-preview">
            <video width="600" controls>
              <source src={file.imageUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
        <p>{file.name}</p>
      </div>

      <div className="selection-section">
        {file.imageUrl.endsWith('.pdf') ? (
          <div className="pdf-selection">
            <h3>Select Lines from PDF</h3>
            {/* Implement PDF selection logic */}
            <button onClick={() => setSelectedLines([...selectedLines, 'Line X'])}>
              Add Line X
            </button>
          </div>
        ) : (
          <div className="video-selection">
            <h3>Select Time Frames from Video</h3>
            {/* Implement video time frame selection logic */}
            <button onClick={() => setSelectedTimeFrames([...selectedTimeFrames, '00:01:00 - 00:02:00'])}>
              Add Time Frame
            </button>
          </div>
        )}
      </div>

      <button className="generate-button" onClick={handleGenerateTemplate}>
        Generate Template
      </button>

      {generatedTemplate && (
        <div className="template-download">
          <p>Generated Template:</p>
          <pre>{generatedTemplate}</pre>
          <button className="download-button" onClick={handleDownloadTemplate}>
            Download Template
          </button>
        </div>
      )}
    </div>
  );
};

export default TemplatePage;

